import { CGameBase, CGameState } from "./CGameBase"
import { CGame } from "./CGame"
import { SoundMgr } from "./SoundMgr";
import { CDefine, CEnumTypes } from "./CEnumTypes";
import { CLoginPlayer } from "./CLoginPlayer";
import { CByteArray } from "./CByteArray";
import { CMJGame } from "./CMJGame";
// import { CMJReplay } from "./CMJReplay";
import { CLobbyTable } from "./CLobbyTable";
import { CConfig } from "./CConfig";
// import { sprintf } from "../typings/sprintf";
import { sprintf } from 'sprintf-js';
import { CPacket } from "./CPacket";

declare var cordova:any;

type OptionParam = {
	mode:string;
	guild?: number;
	btnCnt?: number;
 }

export class CMJLobby extends CGameState {
    private mainView: fgui.GComponent;
	private mGame:CGame = null;
	private m_inText:string;
	private m_inIndex:number;
	private m_curPannel:Array<fgui.GComponent>;
	private static m_instance:CMJLobby = null;
	private m_BaseList:Int32Array;
	private m_BonusList:Int32Array;
	private m_selBase:number;
	private m_selBonus:number;
	private m_selTime:number;
	private m_fgJoinTBL:boolean;
	private m_guildRoomCards:number;
	private m_fgShowName:boolean = true;
	private m_listRecordData:any;
	private m_modeGuild:number;
	private m_sortMode:number;
	private m_multipleBase:number;
	private m_StoreSel:number;
	private m_WebWnd:Window = null;
	private m_createPass:boolean = false;
	private m_Password:string;
	
	public constructor() {
		super();
		this.mGame = CGame.Instance;
	}

	public static get Instance():CMJLobby {
		if( this.m_instance == null ) this.m_instance = new CMJLobby();
		return this.m_instance;
	}

	public Cleanup():void {
		createjs.Tween.removeAllTweens();
		this.mGame.SetGObjectCallbackFunc(this.mainView, this.onClickButton, false, this);
		fgui.GRoot.inst.removeChild(this.mainView);
		this.HideCurPannel();
		this.m_curPannel = null;
		this.mainView.dispose();
		this.mainView = null;
		this.m_BaseList = null;
		this.m_BonusList = null;
		CGame.DebugLog("mjLobbyScene Cleanup done.");
	}

	public Init():void {
		let d = new Date();
		CGame.DebugLog("Used time:", d.getTime() - CGame.Instance.m_tmBlur);

        let ins = fgui.UIPackage.createObject("mjLobbyScene", "mainLobby") as fgui.GComponent;
        ins.setSize(fgui.GRoot.inst.width, fgui.GRoot.inst.height);
		ins.addRelation(fgui.GRoot.inst, fgui.RelationType.Size);
		fgui.GRoot.inst.addChild(ins);

		this.mainView = ins;
		this.m_curPannel = new Array<fgui.GComponent>();
		this.m_selBase = 1;
		this.m_selBonus = 1;
		this.m_selTime = 10;
		this.m_guildRoomCards = 0;
		this.m_modeGuild = -1;
		this.m_sortMode = -1;
		this.mGame.m_clTable.Reset();
		this.m_createPass = false;

		var idx:number;
		for (let i = 0; i < ins.numChildren; i++) {
            let obj = ins.getChildAt(i) as fgui.GComponent;
			if( obj.name.slice(0, 3) == "com" ) obj.visible = false;
		}
		
		this.mGame.SetGObjectCallbackFunc(this.mainView, this.onClickButton, true, this);

		// this.getBulletinData();
		// return;
		// for (let i = 0; i < ins.numChildren; i++) {
        //     let c = ins.getChildAt(i);
        //     let cname = c.name;
        //     if (fgui.utils.StringUtil.startsWith(cname, "btn_")) {
		// 		c.click(this.onClickButton, this);
        //     }
        // }

		let avatar = this.mainView.getChild("avatar") as fgui.GLoader;
		//avatar.url = this.mGame.m_pUserPlayer.pictureURL;
		avatar.texture = PIXI.Texture.from(this.mGame.m_pUserPlayer.pictureURL);
		let t = this.mainView.getChild("txt_RoomCards") as fgui.GTextField;
		t.text = ''+this.mGame.m_pUserPlayer.RoomCards;
		t = this.mainView.getChild("txt_Version") as fgui.GTextField;
		t.text = "v"+CConfig.gameVersion;
		t = this.mainView.getChild("txt_Name") as fgui.GTextField;
		if( this.m_fgShowName ) t.text = this.mGame.m_pUserPlayer.socialName;
		else 					t.text = ""+this.mGame.m_pUserPlayer.DBID;

		var b:fgui.GButton = this.mainView.getChild("btn_Activity") as fgui.GButton;
		b.visible = false;
		b = this.mainView.getChild("btn_Partner") as fgui.GButton;
		b.visible = false;
		b = this.mainView.getChild("btn_Bind") as fgui.GButton;
		b.visible = false;
		b = this.mainView.getChild("btn_Service") as fgui.GButton;
		b.visible = false;
		b = this.mainView.getChild("btn_Rule") as fgui.GButton;
		b.visible = false;
		b = this.mainView.getChild("btn_Back") as fgui.GButton;
		b.visible = false;

		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_ENTER_LOBBY);
		this.mGame.SendData(this.mGame.m_CPkt);

		CGame.DebugLog("mjLobbyScene Init done.");

		// if( CConfig.gameTarget != "H5" ) this.mGame.m_IAP.RestorePurchases(this.onPurchaseSuccess.bind(this));

		if( this.mGame.m_fgInviteGuild ) {
			this.mGame.m_fgInviteGuild = 0;
			this.mGame.ShowDialog("", this.mGame.m_InviteMsg, ["確定"]);
		}

		if( this.mGame.m_fgBulletin == false ) {
			this.mGame.m_fgBulletin = true;
			this.getBulletinData();
		}
		// var that = this;
		// window.addEventListener('keyboardDidShow', function () {
		// 	that.mainView.y = -200;
		// 	// Describe your logic which will be run each time keyboard is shown.
		// });

		// window.addEventListener('keyboardDidHide', function () {
		// 	that.mainView.y = 0;
		// 	// Describe your logic which will be run each time keyboard is closed.
		// });
		// let n = CGame.GetRand(1, 4);
	    // SoundMgr.playMusic("mus/m00"+n+".mp3");
		//createjs.Tween.get(ins).to({x:0}, 500, createjs.Ease.quadOut);
	}

	private onPurchaseSuccess(purchase:any):void {
		CGame.DebugLog(purchase["productId"]);
		CGame.DebugLog(purchase["purchaseId"]);
		CGame.DebugLog(purchase["receipt"]);
		CGame.DebugLog(purchase["purchaseToken"]);

		if( CConfig.gameTarget == "Android") {
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_IAP_VERIFY_ANDROID);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.DBID);
			this.mGame.m_CPkt.WriteShort(purchase["productId"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["productId"], purchase["productId"].length + 1);
			this.mGame.m_CPkt.WriteShort(purchase["purchaseId"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["purchaseId"], purchase["purchaseId"].length + 1);
			this.mGame.m_CPkt.WriteShort(purchase["purchaseToken"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["purchaseToken"], purchase["purchaseToken"].length+1);
			this.mGame.SendData(this.mGame.m_CPkt);
			// this.mGame.ShowDialog("成功", "purchaseId:"+purchase["purchaseId"]+"\npurchaseToken:"+purchase["purchaseToken"], ["確定"]);
			// if( this.getPannelByName("com_StorePage") ) {
			// 	this.LeaveStorePannel();
			// }
		}
		else {
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_IAP_VERIFY_IOS);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.DBID);
			this.mGame.m_CPkt.WriteShort(purchase["productId"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["productId"], purchase["productId"].length + 1);
			this.mGame.m_CPkt.WriteShort(purchase["purchaseId"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["purchaseId"], purchase["purchaseId"].length + 1);
			this.mGame.m_CPkt.WriteShort(purchase["receipt"].length + 1);
			this.mGame.m_CPkt.WriteUTFBytes(purchase["receipt"], purchase["receipt"].length+1);
			this.mGame.SendData(this.mGame.m_CPkt);
		}
	}

	// private onPurchaseFailed(err:string):void {
	// 	this.mGame.ShowDialog("", err, ["確定"]);
	// 	//this.enableStoreButton(true);
	// 	this.ShowStoreComProcess(false);
	// }

	// private OpenWebLink(url:string):void {
	// 	let myWidth = 960;
	// 	let myHeight = 540;
	// 	var left = (screen.width - myWidth) / 2;
    //     var top = (screen.height - myHeight) / 4;
    //     this.m_WebWnd = window.open(url, "加入公會", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
	// }

	private getBulletinData():void {
		this.mGame.DoXmlHttp("GET", CConfig.urlBulletin, null, this.onReceiveBulletinData.bind(this), this.onXmlHttpError.bind(this));
		// this.onReceiveBulletinData('{ "result": "1", "message": "Success!", "Data": "謝淑薇奪得澳網女雙冠軍，生涯第8座大滿貫到手，也破了24年來紀錄，是首位包辦澳網混雙和女雙冠軍的選手。\\n\\n奪下雙冠後，30日晚間，謝淑薇更在臉書發文證實，將代表台灣出戰巴黎奧運。發出貼文，期待巴黎奧運再相見。文章內更表示，「將會從台灣的單打好手裡，挑選適合的搭檔，一起代表台灣出戰。」消息曝光後，讓球迷非常期待。而符合資格的8位選手，也被一一點名。更有網友留言，「詹家姊妹挑一位，世紀大和解。」不過，謝淑薇在2014年仁川亞運邀請詹詠然擔任雙打搭檔，結果遭到拒絕，再加上2017年台北世大運，詹詠然混雙因中暑退賽，也讓雙方因此結下樑子。2017.09台灣網球好手謝淑薇：「我去跟網協反應了，他們也沒有給我們回覆，然後甚至一直在拖，最後決定不再參加國家賽這樣子。」 2016年曾拋出震撼彈，表示不再接受國家隊徵召，如今再度披上國家隊戰袍。謝淑薇也在貼文中表明，「可以使用世界雙打排名前十的奧運規則，任意挑選世界排名前三百的選手為巴黎奧運的雙打搭檔。」因此，最有可能的人選，只剩下楊亞依、葛藍喬安娜和梁恩碩3位。最後將選擇哪一位作為搭檔，也引起許多球迷的熱烈討論。" }');
	}

	private onClickButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if ( btn.name == "btn_Avatar") {
			this.m_fgShowName = !this.m_fgShowName;
			let t = this.mainView.getChild("txt_Name") as fgui.GTextField;
			if( this.m_fgShowName ) t.text = this.mGame.m_pUserPlayer.socialName;
			else 					t.text = ""+this.mGame.m_pUserPlayer.DBID;
		}
		else if ( btn.name == "btn_Share01") {
			this.mGame.LINESendMsg(CConfig.gameURL, "好朋友有空嗎？要不要一起來玩無極麻將？");
		}
		else if ( btn.name == "btn_Share02") {
			this.mGame.ShowEditDialog("請輸入要分享的文字訊息");
			// this.mGame.LINESendMsg(CConfig.gameURL, "");
		}
		else if ( btn.name == "btn_Plus") {
			// if( CConfig.gameTarget != "H5" ) {
			// 	if( this.mGame.m_IAP.m_ProductList.length <= 0 ) {
			// 		this.mGame.ShowDialog("", "商品列表錯誤！", ["確定"]);
			// 	}
			// 	else {
			// 		this.EnterStorePannel();
			// 	}
			// }
		}
		else if ( btn.name == "btn_Records") {
			let dbid:number;
			if( CConfig.testDBID == 0 ) 
				dbid = this.mGame.m_pUserPlayer.DBID;
			else 
				dbid = CConfig.testDBID;
			let url = CConfig.urlRecords + "?Guid=" + dbid;
			CGame.DebugLog(url);
			this.mGame.DoXmlHttp("GET", url, null, this.onReceiveRecordData.bind(this), this.onXmlHttpError.bind(this));
			// this.onReceiveRecordData('{ "result": 1, "message": "Success!", "Data":[ { "Date": "2024/02/23 10:16:36", "RoomIndex": 13709, "Users":[ {"DBID":240100001, "Name":"User01", "Result":1500}, {"DBID":240100002, "Name":"User02", "Result":-1200}, {"DBID":240100003, "Name":"User03", "Result":-800}, {"DBID":240100004, "Name":"User04", "Result":500}] }, { "Date": "2024/01/07 17:26:06", "RoomIndex": 89106, "Users":[ {"DBID":240100001, "Name":"User01", "Result":1500}, {"DBID":240100002, "Name":"User02", "Result":-1200}, {"DBID":240100003, "Name":"User03", "Result":-800}, {"DBID":240100004, "Name":"User04", "Result":500}] }, { "Date": "2024/01/04 12:26:06", "RoomIndex": 38106, "Users":[ {"DBID":240100001, "Name":"User01", "Result":1500}, {"DBID":240100002, "Name":"User02", "Result":-1200}, {"DBID":240100003, "Name":"User03", "Result":-800}, {"DBID":240100004, "Name":"User04", "Result":500}] } ] }');
		}
		else if ( btn.name == "btn_Guild") {
			if( this.mGame.m_pUserPlayer.Guild > 0 )
				this.EnterGuildPannel();
			else {
				this.mGame.ShowDialog("", "您尚未加入公會！", ["確定"]);
				// var that = this;
				// this.mGame.ShowDialog("", "您尚未加入公會！", ["加入公會", "取消"], function (result:boolean) {
				// 	CGame.DebugLog(result);
				// 	if( result ) that.OpenWebLink("https://www.hugashaga.com.tw/");
				// });
			}
		}
		else if ( btn.name == "btn_Bulletin") {
			this.getBulletinData();
		}
		else if ( btn.name == "btn_Setup") {
			this.mGame.ShowSetupDialog();
		}
		else if ( btn.name == "btn_Back") {
			//location.reload();
		}
		else if ( btn.name == "btn_Activity") {
		}
		else if ( btn.name == "btn_Partner") {
			this.mGame.appTakeScreenshot();
		}
		else if ( btn.name == "btn_Bind") {
		}
		else if ( btn.name == "btn_Service") {
		}
		else if ( btn.name == "btn_Rule") {
		}
		else if ( btn.name == "btn_CreateRoom") {
			if( this.mGame.m_pUserPlayer.Guild > 0 ) {
				this.mGame.ShowDialog("", "您已加入公會請移至公會內進行！", ["確定"]);
			}
			else {
				if( this.mGame.m_pUserPlayer.RoomCards <= 0 )
					this.mGame.ShowDialog("", "您的房卡數量不足！", ["確定"]);
				else 
					this.ShowCreateTablePannel(false);
			}
		}
		else if ( btn.name == "btn_JoinRoom") {
			if( this.mGame.m_pUserPlayer.Guild > 0 ) {
				this.mGame.ShowDialog("", "您已加入公會請移至公會內進行！", ["確定"]);
			}
			else {
				let curPannel = this.mainView.getChild("com_JoinRoom") as fgui.GComponent;
				this.m_curPannel.push(curPannel);
				this.m_inIndex = 0;
				for( var i = 0; i < 5; i ++ ) {
					let t = curPannel.getChild("txt_RoomNum"+i) as fgui.GTextField;
					t.text = "";
				}
				this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickJoinRoomButton, true, this);
				curPannel.visible = true;
			}
		}
    }

	private onXmlHttpError(msg:string):void {
		this.mGame.ShowDialog("", msg, ["確定"]);
	}

	private getPannelByName(name:string):fgui.GComponent {
		let com = this.mainView.getChild(name) as fgui.GComponent;
		if( com == null || com.visible == false ) return null;
		return com;
	}

	// private EnterStorePannel():void {
	// 	CGame.DebugLog("EnterStorePannel");
	// 	let rulePannel = this.mainView.getChild("com_CreateRoom") as fgui.GComponent;
	// 	let curPannel = fgui.UIPackage.createObject("mjLobbyScene", "ComponentStore") as fgui.GComponent;
	// 	curPannel.name = "com_StorePage";
	// 	let idx = this.mainView.getChildIndex(rulePannel);
	// 	this.mainView.addChildAt(curPannel, idx-1);
	// 	this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickStorePageButton, true, this);
	// 	for( let i = 0; i < this.mGame.m_IAP.m_ProductList.length; i ++ ) {
	// 		let b = curPannel.getChild("btn_comProduct"+i) as fgui.GComponent;
	// 		let m = b.getChild("mov_BG") as fgui.GMovieClip;
	// 		m.frame = 0;
	// 		let t = b.getChild("txt_Amount") as fgui.GTextField;
	// 		let num = parseInt(this.mGame.m_IAP.m_ProductList[i]["title"].slice(2));
	// 		t.text = num+'張';//this.mGame.m_IAP.m_ProductList[i]["title"].slice(2);
	// 		CGame.DebugLog("amount:", num);
	// 		t = b.getChild("txt_Price") as fgui.GTextField;
	// 		t.text = this.mGame.m_IAP.m_ProductList[i]["priceAsDecimal"]+"元";
	// 	}
	// 	this.ShowStoreComProcess(false);
	// 	curPannel.x = 0;
	// 	curPannel.y = -CGame.gameHT;
	// 	curPannel.visible = true;
	// 	this.m_StoreSel = -1;
	// 	SoundMgr.play("s000");
	// 	createjs.Tween.get(curPannel).to({y:0}, 200, createjs.Ease.quadOut);
	// 	//this.m_curPannel.push(curPannel);
	// 	CGame.DebugLog("EnterStorePannel done.");
	// }

	// private LeaveStorePannel():void {
	// 	let curPannel = this.mainView.getChild("com_StorePage") as fgui.GComponent;
	// 	if( curPannel ) {
	// 		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickStorePageButton, false, this);
	// 		this.mainView.removeChild(curPannel, true);
	// 	}
	// }

	// private resetStoreSelect(idx:number):void {
	// 	let curPannel = this.mainView.getChild("com_StorePage") as fgui.GComponent;
	// 	for( let i = 0; i < 4; i ++ ) {
	// 		let com = curPannel.getChild("btn_comProduct"+i) as fgui.GComponent;
	// 		let m = com.getChild("mov_BG") as fgui.GMovieClip;
	// 		m.frame = 0;
	// 		if( i == idx ) {
	// 			m.frame = 1;
	// 			this.m_StoreSel = i;
	// 		}
	// 	}
	// }

	// private ShowStoreComProcess(show:boolean):void {
	// 	let curPannel = this.mainView.getChild("com_StorePage") as fgui.GComponent;
	// 	let com = curPannel.getChild("com_Process") as fgui.GComponent;
	// 	com.visible = show;
	// }

	// private enableStoreButton(enable:boolean):void {
	// 	let curPannel = this.mainView.getChild("com_StorePage") as fgui.GComponent;
	// 	let b = curPannel.getChild("btn_Confirm") as fgui.GButton;
	// 	b.enabled = enable;
	// 	b = curPannel.getChild("btn_Cancel") as fgui.GButton;
	// 	b.enabled = enable;
	// }

	// private onClickStorePageButton(e: PIXI.InteractionEvent): void {
	// 	let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
	// 	CGame.DebugLog(btn.name);
	// 	if( btn.name == "btn_comProduct0" ) {
	// 		this.resetStoreSelect(0);
	// 	}
	// 	else if( btn.name == "btn_comProduct1" ) {
	// 		this.resetStoreSelect(1);
	// 	}
	// 	else if( btn.name == "btn_comProduct2" ) {
	// 		this.resetStoreSelect(2);
	// 	}
	// 	else if( btn.name == "btn_comProduct3" ) {
	// 		this.resetStoreSelect(3);
	// 	}
	// 	else if( btn.name == "btn_Confirm" ) {
	// 		if( this.m_StoreSel < 0 ) {
	// 			this.mGame.ShowDialog("", "尚未選擇商品！", ["確定"]);
	// 		}
	// 		else {
	// 			//this.enableStoreButton(false);
	// 			this.ShowStoreComProcess(true);
	// 			//this.LeaveStorePannel();
	// 			this.mGame.m_IAP.MakePurchase(this.m_StoreSel, this.onPurchaseSuccess.bind(this), this.onPurchaseFailed.bind(this))
	// 		}
	// 	}
	// 	else if( btn.name == "btn_Cancel" ) {
	// 		this.LeaveStorePannel();
	// 	}
	// }

	private UpdateGuidInfo(p:CByteArray):void {
		CGame.DebugLog("UpdateGuidInfo...");
		let mode = p.readByte();
		let id = p.readInt();
		let roomCards = p.readInt();
		this.m_guildRoomCards = roomCards;
		let curPannel = this.getPannelByName("com_Guild");
		if( curPannel == null ) return;
		let td = curPannel.getChild("txt_RCards") as fgui.GTextField;
		td.text = ""+roomCards;
		if( mode == 0x0f ) {
			let userCount = p.readInt();
			let guildName = p.readUTFBytes(CDefine.GUILDNAME_LEN);
			let guildIcon = p.readUTFBytes(CLoginPlayer.PICTUREURL_LEN);
			let avatar = curPannel.getChild("ava_Guild") as fgui.GLoader;
			CGame.DebugLog("avatar mask:", avatar.displayObject.mask);
			if( guildIcon != "NONE" && avatar.displayObject.mask == null ) {
				avatar.texture = PIXI.Texture.from(guildIcon);
				let graphics = new PIXI.Graphics();
				graphics.beginFill(0xffffff);
				graphics.drawCircle(30+avatar.x, 30+avatar.y, 26);
				graphics.endFill();
				avatar.displayObject.mask = graphics;
			}
			td = curPannel.getChild("txt_Guild") as fgui.GTextField;
			td.text = guildName;
			td = curPannel.getChild("txt_ID") as fgui.GTextField;
			td.text = sprintf("ID: %05d", id);
			td = curPannel.getChild("txt_UserCount") as fgui.GTextField;
			td.text = ""+userCount;
		}
	}

	private GuildRemoveTable(p:CByteArray, list?:fgui.GList):void {
		if( list == undefined ) {
			let curPannel = this.getPannelByName("com_Guild");
			if( curPannel == null ) return;
			let comlist = curPannel.getChild("com_RoomList") as fgui.GComponent;
			list = comlist.getChild("lst_Room") as fgui.GList;
		}
		let index = p.readShort();
		let idxTBl = p.readInt();
		for( var i = 0; i < list.numChildren; i ++ ) {
			let obj = list.getChildAt(i) as fgui.GLabel;
			let td = obj.getChild("txt_TableInfo") as fgui.GTextField;
			let dataAry = td.text.split(",");
			let idxTable = parseInt(dataAry[1]);
			if( idxTBl == idxTable) {
				this.mGame.SetGObjectCallbackFunc(obj, this.onClickGuilRoomListdButton, false, this);
				list.removeChildAt(i, true);
				break;
			}
		}
	}

	private GuildUpdateTable(p:CByteArray, list?:fgui.GList):void {
		if( list == undefined ) {
			let curPannel = this.getPannelByName("com_Guild");
			if( curPannel == null ) return;
			let comlist = curPannel.getChild("com_RoomList") as fgui.GComponent;
			list = comlist.getChild("lst_Room") as fgui.GList;
		}
		let index = p.readShort();
		let idxTBl = p.readInt();
		let base = p.readInt();
		let bonus = p.readInt();
		let secs = p.readChar();
		let rounds = p.readByte();
		let cost = p.readByte();
		let pass = p.readByte();
		let tinGun = p.readByte();
		let tinHu = p.readByte();
		let pcnt = p.readShort();
		for( var i = 0; i < list.numChildren; i ++ ) {
			let obj = list.getChildAt(i) as fgui.GLabel;
			let td = obj.getChild("txt_TableInfo") as fgui.GTextField;
			let dataAry = td.text.split(",");
			let idxTable = parseInt(dataAry[1]);
			if( idxTBl == idxTable) {
				for( var j = 0; j < pcnt; j ++ ) {
					let user = obj.getChild("com_Player"+j) as fgui.GComponent;
					let id = p.readInt();
					let name = p.readUTFBytes(CLoginPlayer.NICKNAME_LEN);
					let picUrl = p.readUTFBytes(CLoginPlayer.PICTUREURL_LEN);
					let avatar = user.getChild("avatar") as fgui.GLoader;
					let tid = "ID "+id;
					if( tid != td.text ) {
						avatar.texture = null;
						avatar.texture = PIXI.Texture.from(picUrl);
						td = user.getChild("txt_Name") as fgui.GTextField;
						td.text = name;
						td = user.getChild("txt_ID") as fgui.GTextField;
						td.text = tid;
					}
					let mv = user.getChild("mov_BG") as fgui.GMovieClip;
					mv.frame = 0;
					if( j > 0 ) {
						let img = user.getChild("img_Star") as fgui.GImage;
						img.visible = false;
					}
				}
				for( ; j < 4; j ++ ) {
					let user = obj.getChild("com_Player"+j) as fgui.GComponent;
					let avatar = user.getChild("avatar") as fgui.GLoader;
					td = user.getChild("txt_ID") as fgui.GTextField;
					if( td.text != "" ) {
						avatar.texture = null;
						td.text = "";
						td = user.getChild("txt_Name") as fgui.GTextField;
						td.text = "";
					}
					let mv = user.getChild("mov_BG") as fgui.GMovieClip;
					mv.frame = 1;
					let img = user.getChild("img_Star") as fgui.GImage;
					img.visible = false;
				}
				let b = obj.getChild("btn_Join") as fgui.GButton;
				if( pcnt >= 4 ) b.visible = false;
				else 			b.visible = true;
				break;
			}
		}
	}

	private GuildAddTable(p:CByteArray, list?:fgui.GList):void {
		if( list == undefined ) {
			let curPannel = this.getPannelByName("com_Guild");
			if( curPannel == null ) return;
			let comlist = curPannel.getChild("com_RoomList") as fgui.GComponent;
			list = comlist.getChild("lst_Room") as fgui.GList;
		}
		let index = p.readShort();
		let idxTBl = p.readInt();
		let base = p.readInt();
		let bonus = p.readInt();
		let secs = p.readChar();
		let rounds = p.readByte();
		let cost = p.readByte();
		let pass = p.readByte();
		let tinGun = p.readByte();
		let tinHu = p.readByte();
		let pcnt = p.readShort();
		let obj = fgui.UIPackage.createObject("mjLobbyScene", "LabelListItem01") as fgui.GLabel;
		let td = obj.getChild("txt_TableInfo") as fgui.GTextField;
		td.text = index+","+idxTBl+","+base+","+bonus+","+secs+","+rounds+","+cost+","+pass+","+tinGun+","+tinHu;
		td = obj.getChild("txt_RoomNum") as fgui.GTextField;
		td.text = "房號:"+idxTBl;
		obj.title = ""+idxTBl;
		td = obj.getChild("txt_RuleBase") as fgui.GTextField;
		td.text = "底/台 "+base+"/"+bonus;
		td = obj.getChild("txt_RoomRound") as fgui.GTextField;
		td.text = rounds+"圈";
		td = obj.getChild("txt_Cost") as fgui.GTextField;
		if( cost == 0 ) td.text = "玩家均攤";
		else 			td.text = "公會扣卡";
		td = obj.getChild("txt_Date") as fgui.GTextField;
		td.text = secs+"秒  ";
		if( tinGun ) td.text += "聽牌可以明槓  ";
		else 		 td.text += "聽牌不可以明槓  ";
		if( tinHu ) td.text += "按聽後強制胡牌  ";
		else 		td.text += "按聽後不強制胡牌  ";
		if( pass ) td.text += "需密碼";
		for( var j = 0; j < pcnt; j ++ ) {
			let user = obj.getChild("com_Player"+j) as fgui.GComponent;
			let id = p.readInt();
			let name = p.readUTFBytes(CLoginPlayer.NICKNAME_LEN);
			let picUrl = p.readUTFBytes(CLoginPlayer.PICTUREURL_LEN);
			let avatar = user.getChild("avatar") as fgui.GLoader;
			avatar.texture = PIXI.Texture.from(picUrl);
			let mv = user.getChild("mov_BG") as fgui.GMovieClip;
			mv.frame = 0;
			td = user.getChild("txt_Name") as fgui.GTextField;
			td.text = name;
			td = user.getChild("txt_ID") as fgui.GTextField;
			td.text = "ID "+id;
			if( j > 0 ) {
				let img = user.getChild("img_Star") as fgui.GImage;
				img.visible = false;
			}
		}
		for( ; j < 4; j ++ ) {
			let user = obj.getChild("com_Player"+j) as fgui.GComponent;
			let mv = user.getChild("mov_BG") as fgui.GMovieClip;
			mv.frame = 1;
			let img = user.getChild("img_Star") as fgui.GImage;
			img.visible = false;
		}
		let b = obj.getChild("btn_Join") as fgui.GButton;
		if( pcnt >= 4 ) b.visible = false;
		else 			b.visible = true;
		list.addChild(obj);
		this.mGame.SetGObjectCallbackFunc(obj, this.onClickGuilRoomListdButton, true, this);
	}

	private onReceiveGuildEnterData(p:CByteArray):void {
		let curPannel = this.getPannelByName("com_Guild");
		if( curPannel == null ) return;
		let comlist = curPannel.getChild("com_RoomList") as fgui.GComponent;
		let list = comlist.getChild("lst_Room") as fgui.GList;
		list.on(fgui.ListEvent.ItemClick, this.onGuildRoomListItemClick, this);
		let cnt = p.readInt();
		for( var i = 0; i < cnt; i ++ ) {
			this.GuildAddTable(p, list);
		}
	}

	private updateRankingItem(data:any, lab:fgui.GLabel, rank:number, bgFrame:number = 0):void {
		lab.visible = true;
		let img = lab.getChild("img_Pointer") as fgui.GImage;
		img.visible = false;
		if( bgFrame == 1 ) {
			img.visible = true;
			let mv = lab.getChild("mov_BG") as fgui.GMovieClip;
			mv.frame = 1;
		}
		let mov = lab.getChild("mov_Rank") as fgui.GMovieClip;
		let td = lab.getChild("txt_Rank") as fgui.GTextField;
		if( rank <= 3 ) {
			mov.visible = true;
			mov.frame = rank-1;
			td.visible = false;
		}
		else {
			mov.visible = false;
			td.visible = true;
			td.text = ""+rank;
		}
		td = lab.getChild("txt_DBID") as fgui.GTextField;
		td.text = data.DBID;
		td = lab.getChild("txt_Name") as fgui.GTextField;
		td.text = data.Name;
		td = lab.getChild("txt_Score") as fgui.GTextField;
		td.text = ""+data.Score;
		td = lab.getChild("txt_Rounds") as fgui.GTextField;
		td.text = ""+data.Innings;
		td = lab.getChild("txt_Wins") as fgui.GTextField;
		td.text = ""+data.Winners;
		td = lab.getChild("txt_CardUsed") as fgui.GTextField;
		td.text = ""+data.CardUsed;
	}

	private onReceiveRankdData(data:string):void {
		let json = JSON.parse(data);
		if( json.result == 1 ) {
			let curPannel = this.getPannelByName("com_Guild");
			if( curPannel == null ) return;
			let comRk = curPannel.getChild("com_RankList") as fgui.GComponent;
			if( json.Ranking != undefined ) {
				let lab = comRk.getChild("lab_Rank"+5) as fgui.GLabel;
				this.updateRankingItem(json.RankList[0], lab, json.Ranking, 1);
			}
			else {
				for( var i = 0; i < 6; i ++ ) {
					let lab = comRk.getChild("lab_Rank"+i) as fgui.GLabel;
					if( i >= json.RankList.length ) {
						lab.visible = false;
						continue;
					}
					this.updateRankingItem(json.RankList[i], lab, i+1);
				}
			}
		}
		else {
			this.mGame.ShowDialog("", json.message, ["確定"]);
		}
	}

	private SwitchRankSortMode(mode:number):void {
		if( this.m_sortMode != mode ) {
			this.m_sortMode = mode;

			let curPannel = this.m_curPannel[this.m_curPannel.length-1];
			let comRk = curPannel.getChild("com_RankList") as fgui.GComponent;
			let t = comRk.getChild("inp_IDSearch") as fgui.GTextInput;
			t.text = "";
			let nameAry = [ "btn_movScore", "btn_movRounds", "btn_movWinner", "btn_movCardUsed"];
			for( var i = 0; i < nameAry.length; i ++ ) {
				let mov = comRk.getChild(nameAry[i]) as fgui.GMovieClip;
				if( i == mode ) mov.frame = 1;
				else 			mov.frame = 0;
			}
			this.mGame.DoXmlHttp("GET", CConfig.urlRanking+"?DBID=&sort="+this.m_sortMode+"&Guild="+this.mGame.m_pUserPlayer.Guild, null, this.onReceiveRankdData.bind(this), this.onXmlHttpError.bind(this));
		}
	}

	private GuildSwitch2RoomORRank(mode:number):void {
		if( mode == -1 ) mode = 0;
		if( mode == this.m_modeGuild ) return;

		let curPannel = this.m_curPannel[this.m_curPannel.length-1];

		let btnRm = curPannel.getChild("btn_movRoom") as fgui.GMovieClip;
		let btnRk = curPannel.getChild("btn_movRank") as fgui.GMovieClip;
		let comRm = curPannel.getChild("com_RoomList") as fgui.GComponent;
		let comRk = curPannel.getChild("com_RankList") as fgui.GComponent;

		if( mode == 0 ) {
			btnRm.frame = 1;
			btnRk.frame = 0;
		
			comRm.visible = true;
			comRk.visible = false;

			if( this.m_modeGuild == 1 ) this.mGame.SetGObjectCallbackFunc(comRk, this.onClickRankButton, false, this);
		}
		else {
			btnRm.frame = 0;
			btnRk.frame = 1;
		
			comRm.visible = false;
			comRk.visible = true;

			this.mGame.SetGObjectCallbackFunc(comRk, this.onClickRankButton, true, this);
			let t = comRk.getChild("inp_IDSearch") as fgui.GTextInput;
			t.text = "";

			if( this.m_sortMode == -1 ) this.SwitchRankSortMode(0);
		}
		this.m_modeGuild = mode;
	}

	private EnterGuildPannel():void {
		let curPannel = this.mainView.getChild("com_Guild") as fgui.GComponent;
		this.m_curPannel.push(curPannel);
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickGuildButton, true, this);

		this.GuildSwitch2RoomORRank(this.m_modeGuild);

		let avatar = curPannel.getChild("ava_User") as fgui.GLoader;
		avatar.texture = PIXI.Texture.from(this.mGame.m_pUserPlayer.pictureURL);
		let graphics = new PIXI.Graphics();
		graphics.beginFill(0xffffff);
		graphics.drawCircle(20+avatar.x, 20+avatar.y, 16);
		graphics.endFill();
		avatar.displayObject.mask = graphics;

		let td = curPannel.getChild("txt_UserName") as fgui.GTextField;
		td.text = this.mGame.m_pUserPlayer.socialName;
		td = curPannel.getChild("txt_UserID") as fgui.GTextField;
		td.text = "ID:"+this.mGame.m_pUserPlayer.DBID;
		td = curPannel.getChild("txt_Cards") as fgui.GTextField;
		td.text = ""+this.mGame.m_pUserPlayer.RoomCards;
		td = curPannel.getChild("txt_Golds") as fgui.GTextField;
		let g = this.mGame.m_pUserPlayer.Gold / CDefine.GOLD_MULTI_BASE;
		td.text = ""+g.toFixed(1);
		curPannel.visible = true;

		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_GUILD_ENTER);
		this.mGame.SendData(this.mGame.m_CPkt);
	}

	private LeaveGuildPannel():void {
		let curPannel = this.getPannelByName("com_Guild");
		if( curPannel == null ) return;
		if( this.m_modeGuild == 1 ) {
			let comRk = curPannel.getChild("com_RankList") as fgui.GComponent;
			this.mGame.SetGObjectCallbackFunc(comRk, this.onClickRankButton, false, this);
		}
		let comlist = curPannel.getChild("com_RoomList") as fgui.GComponent;
		let list = comlist.getChild("lst_Room") as fgui.GList;
		list.off(fgui.ListEvent.ItemClick, this.onGuildRoomListItemClick, this);
		CGame.DebugLog("list numChildren:", list.numChildren);
		for( var i = 0; i < list.numChildren; i ++ ) {
			let obj = list.getChildAt(i) as fgui.GLabel;
			this.mGame.SetGObjectCallbackFunc(obj, this.onClickGuilRoomListdButton, false, this);			
		}
		list.removeChildren(0, list.numChildren, true);

		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickGuildButton, false, this);
		curPannel.visible = false;
		this.m_curPannel.pop();

		let cPkt = new CPacket(64);
		cPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		cPkt.WriteByte(CEnumTypes.ID_MSG_GUILD_LEAVE);
		this.mGame.SendData(cPkt);
	}

	private onClickRankButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		if( btn.name == "btn_IDSearch" ) {
			let curPannel = this.m_curPannel[this.m_curPannel.length-1];
			let comRk = curPannel.getChild("com_RankList") as fgui.GComponent;
			let t = comRk.getChild("inp_IDSearch") as fgui.GTextInput;
			if( t.text == "" || t.text.length < 9 ) {
				let msg:string = "請輸入玩家正確的ID!";
				this.mGame.ShowDialog("", msg, ["確定"]);
			}
			else {
				this.mGame.DoXmlHttp("GET", CConfig.urlRanking+"?DBID="+t.text+"&sort="+this.m_sortMode+"&Guild="+this.mGame.m_pUserPlayer.Guild, null, this.onReceiveRankdData.bind(this), this.onXmlHttpError.bind(this));
			}
		}
		else if( btn.name == "btn_movScore" ) {
			this.SwitchRankSortMode(0);
		}
		else if( btn.name == "btn_movRounds" ) {
			this.SwitchRankSortMode(1);
		}
		else if( btn.name == "btn_movWinner" ) {
			this.SwitchRankSortMode(2);
		}
		else if( btn.name == "btn_movCardUsed" ) {
			this.SwitchRankSortMode(3);
		}
	}

	private onClickGuildButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		if( btn.name == "btn_Close" ) {
			this.LeaveGuildPannel();
		}
		else if( btn.name == "btn_CreateRoom" ) {
			this.ShowCreateTablePannel(false, 2, this.mGame.m_pUserPlayer.Guild);
		}
		else if( btn.name == "btn_QuitGuild" ) {
			this.LeaveGuildPannel();
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_QUIT_GUILD);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.Guild);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.DBID);
			this.mGame.SendData(this.mGame.m_CPkt);
		}
		else if( btn.name == "btn_Invite" ) {
			let curPannel = this.getPannelByName("com_Guild");
			if( curPannel == null ) return;
			let td = curPannel.getChild("txt_Guild") as fgui.GTextField;
			let guildName = td.text;
			let id = sprintf("%05d", this.mGame.m_pUserPlayer.Guild);
			let cb = new CByteArray(64);
			let ofs = 0;
			let d = new Date();
			cb.SetInt(ofs, this.mGame.m_pUserPlayer.DBID); ofs += 4;
			cb.SetUTFBytes(ofs, id); ofs += 5;
			cb.SetUTFBytes(ofs, guildName); ofs += CDefine.GUILDNAME_LEN;
			cb.SetUTFBytes(ofs, d.toLocaleString("en-ZA")); ofs += 24;
			let base64 = CGame.bytesToBase64(cb);
			let url = CConfig.gameURL+"?p=100&data="+base64;
			CGame.DebugLog(url);
			//let tb = CGame.base64ToBytes(base64);
			//let p:CByteArray = new CByteArray(tb);
			//CGame.DebugLog("decode base64:", p.readInt(), p.readUTFBytes(5), p.readUTFBytes(CDefine.GUILDNAME_LEN));
			//let url = CConfig.gameURL+"?p=100&guild="+id+"&inviter="+this.mGame.m_pUserPlayer.DBID+"&guildname="+guildName;
			this.mGame.LINESendMsg(url, "邀請加入公會\n\n無極麻將『"+guildName+"』公會（編號"+id+"）誠摯歡迎您的加入!請從以下連結進入:");
		}
		else if( btn.name == "btn_movRoom" ) {
			this.GuildSwitch2RoomORRank(0);
		}
		else if( btn.name == "btn_movRank" ) {
			this.GuildSwitch2RoomORRank(1);
		}
	}

	private onClickPasswordButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		if ( btn.name == "btn_Cancel") SoundMgr.play("s012");
		else if ( btn.name == "btn_Confirm") SoundMgr.play("s002");
		else SoundMgr.play("s001");
		if ( btn.name == "btn_Confirm") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickPasswordButton, false, this);
			curPannel.visible = false;
			let str:string = "";
			for( var i = 0; i < 5; i ++ ) {
				let t = curPannel.getChild("txt_Password"+i) as fgui.GTextField;
				str += t.text;
			}
			CGame.DebugLog("Password: ", str);
			this.m_curPannel.pop();

			// if( this.m_createPass ) {
				this.m_createPass = false;
				//this.m_Password = str;
				curPannel = this.m_curPannel[this.m_curPannel.length-1];
				let t = curPannel.getChild("txt_Password") as fgui.GTextField;
				t.text = str;
			// }
			// else {
			// 	this.mGame.resetPacket();
			// 	this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			// 	this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_JOIN);
			// 	this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.Guild);
			// 	this.mGame.m_CPkt.WriteShort(this.mGame.m_clTable.index);
			// 	this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
			// 	this.mGame.m_CPkt.WriteChar(this.mGame.m_clTable.fgPass);
			// 	this.mGame.m_CPkt.WriteUTFBytes(str, 6);
			// 	this.mGame.SendData(this.mGame.m_CPkt);
			// }
		}
		else if ( btn.name == "btn_Cancel") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickPasswordButton, false, this);
			curPannel.visible = false;
			this.m_curPannel.pop();
		}
		else if ( btn.name.slice(0, 7) == "btn_Num") {
			if( btn.name.length >= 9 ) {
				let n = this.m_inIndex - 1;
				if( n >= 0 ) {
					let t = curPannel.getChild("txt_Password"+n) as fgui.GTextField;
					t.text = "";
					this.m_inIndex = n;
				}
			}
			else if( this.m_inIndex < 5 ) {
				let n = parseInt(btn.name.slice(-1));
				CGame.DebugLog(n);
				let t = curPannel.getChild("txt_Password"+this.m_inIndex) as fgui.GTextField;
				t.text = n.toString();
				this.m_inIndex ++;
			}
		}
    }

	private ShowPasswordPannel():void {
		let curPannel = this.mainView.getChild("com_Password") as fgui.GComponent;
		this.m_curPannel.push(curPannel);
		this.m_inIndex = 0;
		for( var i = 0; i < 5; i ++ ) {
			let t = curPannel.getChild("txt_Password"+i) as fgui.GTextField;
			t.text = "";
		}
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickPasswordButton, true, this);
		curPannel.visible = true;
	}

	private onClickGuilRoomListdButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		if( btn.name == "btn_Join" ) {
			let obj = btn.parent as fgui.GLabel;
			CGame.DebugLog(obj.title, obj.name);
			let td = obj.getChild("txt_TableInfo") as fgui.GTextField;
			//td.text = index+","+idxTBl+","+base+","+bonus+","+secs+","+rounds+","+cost+","+pass+","+tinGun+","+tinHu;
			let mary = td.text.split(",");
			let base = parseInt(mary[2]);
			let fgPass = parseInt(mary[6]);
			this.mGame.m_clTable.index = parseInt(mary[0]);
			this.mGame.m_clTable.idxTable = parseInt(mary[1]);
			this.mGame.m_clTable.Base = base;
			this.mGame.m_clTable.Bonus = parseInt(mary[3]);
			this.mGame.m_clTable.Secs = parseInt(mary[4]);
			this.mGame.m_clTable.Round = parseInt(mary[5]);
			this.mGame.m_clTable.Cost = parseInt(mary[6]);
			this.mGame.m_clTable.fgPass = parseInt(mary[7]);
			this.mGame.m_clTable.fgTinGun = parseInt(mary[8]);
			this.mGame.m_clTable.fgTingHu = parseInt(mary[9]);
			if( fgPass ) {
				this.ShowPasswordPannel();
			}
			else {
				if( this.mGame.m_clTable.Cost == 0 && this.mGame.m_pUserPlayer.RoomCards < 1 ) {
					this.mGame.ShowDialog("", "您的房卡數量不足！", ["確定"]);
				}
				else if( this.mGame.m_pUserPlayer.Gold < this.m_multipleBase*base) {
					this.mGame.ShowDialog("", "您擁有的本金少於"+this.m_multipleBase+"底!!", ["確定"]);
				}
				else {
					this.LeaveGuildPannel();
					this.mGame.resetPacket();
					this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
					this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_JOIN);
					this.mGame.m_CPkt.WriteInt(this.mGame.m_pUserPlayer.Guild);
					this.mGame.m_CPkt.WriteShort(parseInt(mary[0]));
					this.mGame.m_CPkt.WriteInt(parseInt(mary[1]));
					this.mGame.m_CPkt.WriteChar(parseInt(mary[6]));
					this.mGame.SendData(this.mGame.m_CPkt);
				}
			}
			
		}
	}

	private onGuildRoomListItemClick(e: PIXI.InteractionEvent):void {
		let obj = fgui.GObject.castFromNativeObject(e.currentTarget);
		let item = obj as fgui.GLabel;
		let idx = parseInt(item.name);
		CGame.DebugLog(item.title);
	}

	private onClickBulletinButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		if( btn.name == "btn_Close" ) {
			let curPannel = this.m_curPannel[this.m_curPannel.length-1];
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickBulletinButton, false, this);
			curPannel.visible = false;
			this.m_curPannel.pop();
		}
	}

	private onReceiveBulletinData(data:string):void {
		let json = JSON.parse(data);
		CGame.DebugLog(data);
		if( json.result == 1 ) {
			let curPannel = this.mainView.getChild("com_Bulletin") as fgui.GComponent;
			this.m_curPannel.push(curPannel);
			let com = curPannel.getChild("com_Content") as fgui.GComponent;
			let t = com.getChild("txt_Bulletin") as fgui.GTextField;
			t.text = json.Data;
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickBulletinButton, true, this);
			curPannel.visible = true;
		}
		else {
			this.mGame.ShowDialog("", json.message, ["確定"]);
		}
	}

	private onReceiveRecordData(data:string):void {
		this.m_listRecordData = JSON.parse(data);
		if( this.m_listRecordData.result == 1 ) {
			let curPannel = this.mainView.getChild("com_Records") as fgui.GComponent;
			this.m_curPannel.push(curPannel);
			let list = curPannel.getChild("lst_Records") as fgui.GList;
			// list.on(fgui.ListEvent.ItemClick, this.onListItemClick, this);
			for( var i = 0; i < this.m_listRecordData.Data.length; i ++ ) {
				let obj = fgui.UIPackage.createObject("mjLobbyScene", "LabelListItem") as fgui.GLabel;
				let data = this.m_listRecordData.Data[i];
				let td = obj.getChild("m_txtDate") as fgui.GTextField;
				td.text = data.Date;
				let tt = obj.getChild("m_txtRoomIndex") as fgui.GTextField;
				tt.text = ""+data.RoomIndex;
				let players = data.Users.length;
				if( players > 4 ) players = 4;
				for( var j = 0; j < players; j ++ ) {
					let c = obj.getChild("com_Player"+j) as fgui.GComponent;
					td = c.getChild("txt_Name") as fgui.GTextField;
					td.text = data.Users[j].Name;
					td = c.getChild("txt_Score") as fgui.GTextField;
					td.text = data.Users[j].Result;
					if( data.Users[j].Result >= 0 ) td.color = 0x00FF00;
					else 							td.color = 0xFF0000;
				}
				obj.name = i.toString();
				list.addChild(obj);
			}
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickRecordsButton, true, this);
			curPannel.visible = true;
		}
		else {
			this.mGame.ShowDialog("", this.m_listRecordData.message, ["確定"]);
		}
	}

	private HideRecordPanel():void {
		if( this.m_curPannel.length <= 0 ) return;
		let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		let list = curPannel.getChild("lst_Records") as fgui.GList;
		// list.off(fgui.ListEvent.ItemClick, this.onListItemClick, this);
		list.removeChildren(0, list.numChildren, true);
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickRecordsButton, false, this);
		curPannel.visible = false;
		this.m_curPannel.pop();
	}

	private onListItemClick(e: PIXI.InteractionEvent):void {
		let obj = fgui.GObject.castFromNativeObject(e.currentTarget);
		let item = obj as fgui.GLabel;
		let idx = parseInt(item.name);
		CGame.DebugLog(item.title);
		CGame.DebugLog(idx);
		//CGame.DebugLog(JSON.stringify(this.m_listRecordData.Data[idx]));
		let td = item.getChild("m_txtDate") as fgui.GTextField;
		let tt = item.getChild("m_txtRoomIndex") as fgui.GTextField;
		CGame.DebugLog("Date:", td.text);
		CGame.DebugLog("RoomIndex:", parseInt(tt.text));
		this.HideRecordPanel();
		this.RequestRePlayData(this.m_listRecordData.Data[idx].Date, this.m_listRecordData.Data[idx].RoomIndex);
	}

	private onClickRecordsButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		if( btn.name == "btn_Cancel" ) {
			this.HideRecordPanel();
		}
		// else if( btn.name == "btn_Del" ) {
		// 	let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		// 	let list = curPannel.getChild("lst_Records") as fgui.GList;
		// 	list.removeChildAt(1, true);
		// }
	}

	private RequestRePlayData(date:string, idxTable:number):void {
	//private RequestRePlayData(idxTable:number):void {
		let d = new Date(date);
		d.setDate(d.getDate() - 1);
		//d.setDate(d.getDate() - 30);
		let d1 = d.toLocaleDateString("en-CA");//.replace(/[/]/g,"-");
		d = new Date(date);
		d.setDate(d.getDate() + 1);
		let d2 = d.toLocaleDateString("en-CA");//.replace(/[/]/g,"-");

		CGame.DebugLog("start " + d1 + ", end " + d2);

		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_REQUEST_REPLAY);
		this.mGame.m_CPkt.WriteInt(idxTable);
		let size = d1.length + 1;
		this.mGame.m_CPkt.WriteShort(size);
		this.mGame.m_CPkt.WriteUTFBytes(d1, size);
		size = d2.length + 1;
		this.mGame.m_CPkt.WriteShort(size);
		this.mGame.m_CPkt.WriteUTFBytes(d2, size);
		this.mGame.SendData(this.mGame.m_CPkt);
	}

	private ShowCreateTablePannel(readonly:boolean, btnCnt:number = 2, guild:number = 0):void {
		let curPannel = this.mainView.getChild("com_CreateRoom") as fgui.GComponent;
		this.m_curPannel.push(curPannel);
		this.m_fgJoinTBL = readonly;

		let gt = curPannel.getChild("txt_guildID") as fgui.GTextField;
		gt.text = ""+guild;

		let fgPass = 0;
		let base = this.m_BaseList[this.m_selBase];
		let bonus = this.m_BonusList[this.m_selBonus];
		let time = this.m_selTime;
		let t = curPannel.getChild("txt_Title") as fgui.GTextField;
		let c = curPannel.getController("cCard");
		if( readonly ) {
			t.text = "加入房間";
			base = this.mGame.m_clTable.Base;
			bonus = this.mGame.m_clTable.Bonus;
			time = this.mGame.m_clTable.Secs;
			c.selectedIndex = this.mGame.m_clTable.Cost;
		}
		else {
			t.text = "創建房間";
			c.selectedIndex = 0;
		}
		if( btnCnt == 1 ) t.text = "房間規則";
		t = curPannel.getChild("txt_Cost") as fgui.GTextField;
		if( c.selectedIndex == 0 ) t.text = "1";
		else 					   t.text = "4";

		t = curPannel.getChild("txt_Base") as fgui.GTextField;
		t.text = base + '';
		t = curPannel.getChild("txt_Bonus") as fgui.GTextField;
		t.text = bonus + '';
		t = curPannel.getChild("txt_Time") as fgui.GTextField;
		t.text = time + '';
		t = curPannel.getChild("txt_Password") as fgui.GTextField;
		t.text = "";
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickCreateRoomButton, true, this);
		if( readonly ) {
			c = curPannel.getController("cTingGun");
			c.selectedIndex = this.mGame.m_clTable.fgTinGun;
			c = curPannel.getController("cRound");
			c.selectedIndex = this.mGame.m_clTable.Round >> 1;
			c = curPannel.getController("cPassword");
			c.selectedIndex = this.mGame.m_clTable.fgPass;
			for( let i = 0; i < curPannel.numChildren; i ++ ) {
				let b = curPannel.getChildAt(i);
				if (fgui.utils.StringUtil.startsWith(b.name, "btn_")) {
					if( b.name != "btn_Cancel" && b.name != "btn_Confirm" ) {
						b.enabled = false;
					}
				}
			}
			if( this.mGame.m_clTable.fgPass && btnCnt > 1 ) {
				fgPass = 1;
				let b = curPannel.getChild("btn_Password") as fgui.GButton;
				b.enabled = true;
			}
			
		}
		else {
			c = curPannel.getController("cTingGun");
			c.selectedIndex = 0;
			c = curPannel.getController("cRound");
			c.selectedIndex = 0;
			c = curPannel.getController("cPassword");
			c.selectedIndex = 0;
		}
		let b = curPannel.getChild("btn_Cancel") as fgui.GButton;
		b.visible = true;
		if( btnCnt == 1 ) b.visible = false;

		b = curPannel.getChild("btn_RadioCard2") as fgui.GButton;
		if( guild == 0 ) {
			b.visible = false;
		}
		else {
			b.visible = true;
		}
		
		curPannel.visible = true;
		// if( fgPass ) {
		// 	this.ShowPasswordPannel();
		// }
	}

	private onClickCreateRoomButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		let gt = curPannel.getChild("txt_guildID") as fgui.GTextField;
		let guild = parseInt(gt.text);
		let bCancel = curPannel.getChild("btn_Cancel") as fgui.GButton;
		if ( btn.name == "btn_Cancel") SoundMgr.play("s012");
		else if ( btn.name == "btn_Confirm") SoundMgr.play("s002");
		else SoundMgr.play("s001");
		if ( btn.name == "btn_Confirm") {
			let fgSend = 0;
			let gt = curPannel.getChild("txt_guildID") as fgui.GTextField;
			let guild = parseInt(gt.text);
			if( bCancel.visible ) {
				let c = curPannel.getController("cPassword");
				if( c.selectedIndex == 1 ) {
					let t = curPannel.getChild("txt_Password") as fgui.GTextField;
					if( t.text == "" ) {
						let msg:string = "請設定密碼!";
						if( this.m_fgJoinTBL ) msg = "請輸入密碼!";
						this.mGame.ShowDialog("", msg, ["確定"]);
						return;
					}
				}
				this.mGame.resetPacket();
				this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
				if( this.m_fgJoinTBL ) {
					if( this.mGame.m_clTable.Cost == 0 && this.mGame.m_pUserPlayer.RoomCards < 1 ) {
						this.mGame.ShowDialog("", "您的房卡數量不足！", ["確定"]);
					}
					else {
						this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_JOIN);
						this.mGame.m_CPkt.WriteInt(guild);
						this.mGame.m_CPkt.WriteShort(this.mGame.m_clTable.index);
						this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
						this.mGame.m_CPkt.WriteChar(this.mGame.m_clTable.fgPass);
						if( this.mGame.m_clTable.fgPass ) {
							let t = curPannel.getChild("txt_Password") as fgui.GTextField;
							this.mGame.m_CPkt.WriteUTFBytes(t.text, 6);
						}
						fgSend = 1;
					}
				}
				else {
					c = curPannel.getController("cCard");
					let card = c.selectedIndex;
					//if( card == 1 && this.mGame.m_pUserPlayer.RoomCards < 4 ) {
					if( card == 1 && this.m_guildRoomCards < 4 ) {
						this.mGame.ShowDialog("", "公會房卡數量不足！", ["確定"]);
					}
					else if( guild > 0 && this.mGame.m_pUserPlayer.Gold < this.m_multipleBase*this.m_BaseList[this.m_selBase]) {
						this.mGame.ShowDialog("", "您擁有的本金少於"+this.m_multipleBase+"底!!", ["確定"]);
					}
					else {
						this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_CREATE);
						this.mGame.m_CPkt.WriteInt(guild);
						this.mGame.m_CPkt.WriteInt(this.m_BaseList[this.m_selBase]);
						this.mGame.m_CPkt.WriteInt(this.m_BonusList[this.m_selBonus]);
						this.mGame.m_CPkt.WriteByte(this.m_selTime);
						c = curPannel.getController("cTingGun");
						this.mGame.m_CPkt.WriteByte(c.selectedIndex);
						c = curPannel.getController("cTingHu");
						this.mGame.m_CPkt.WriteByte(c.selectedIndex);
						c = curPannel.getController("cRound");
						this.mGame.m_CPkt.WriteByte(1 << c.selectedIndex);
						this.mGame.m_CPkt.WriteByte(card);
						c = curPannel.getController("cPassword");
						this.mGame.m_CPkt.WriteByte(c.selectedIndex);
						if( c.selectedIndex == 1 ) {
							let t = curPannel.getChild("txt_Password") as fgui.GTextField;
							this.mGame.m_CPkt.WriteUTFBytes(t.text, 6);
						}
						fgSend = 1;
					}
				}
			}
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickCreateRoomButton, false, this);
			curPannel.visible = false;
			this.m_curPannel.pop();

			if( guild != 0 ) {
				this.LeaveGuildPannel();
			}
			if( fgSend ) {
				CGame.DebugLog("onClickCreateRoomButton SendData !");
				this.mGame.SendData(this.mGame.m_CPkt);
			}
		}
		else if ( btn.name == "btn_Cancel") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickCreateRoomButton, false, this);
			curPannel.visible = false;
			this.m_curPannel.pop();
		}
		else if ( btn.name == "btn_BaseL") {
			if( this.m_selBase > 1 ) {
				this.m_selBase --;
				let t = curPannel.getChild("txt_Base") as fgui.GTextField;
				t.text = this.m_BaseList[this.m_selBase].toString();
			}
		}
		else if ( btn.name == "btn_BaseR") {
			if( this.m_selBase < this.m_BaseList[0] ) {
				this.m_selBase ++;
				let t = curPannel.getChild("txt_Base") as fgui.GTextField;
				t.text = this.m_BaseList[this.m_selBase].toString();
			}
		}
		else if ( btn.name == "btn_BonusL") {
			if( this.m_selBonus > 1 ) {
				this.m_selBonus --;
				let t = curPannel.getChild("txt_Bonus") as fgui.GTextField;
				t.text = this.m_BonusList[this.m_selBonus].toString();
			}
		}
		else if ( btn.name == "btn_BonusR") {
			if( this.m_selBonus < this.m_BonusList[0] ) {
				this.m_selBonus ++;
				let t = curPannel.getChild("txt_Bonus") as fgui.GTextField;
				t.text = this.m_BonusList[this.m_selBonus].toString();
			}
		}
		else if ( btn.name == "btn_TimeL") {
			if( this.m_selTime > 3 ) {
				this.m_selTime --;
				let t = curPannel.getChild("txt_Time") as fgui.GTextField;
				t.text = this.m_selTime+"";
			}
		}
		else if ( btn.name == "btn_TimeR") {
			if( this.m_selTime < 15 ) {
				this.m_selTime ++;
				let t = curPannel.getChild("txt_Time") as fgui.GTextField;
				t.text = this.m_selTime+"";
			}
		}
		else if( btn.name == "btn_RadioCard1") {
			let t = curPannel.getChild("txt_Cost") as fgui.GTextField;
			t.text = "1";
		}
		else if( btn.name == "btn_RadioCard2") {
			let t = curPannel.getChild("txt_Cost") as fgui.GTextField;
			t.text = "4";
		}
		else if( btn.name == "btn_RadioPass2") {
			this.m_createPass = true;
			this.ShowPasswordPannel();
			// let t = curPannel.getChild("txt_Password") as fgui.GTextInput;
			// //t.restrict = "^[0-9]+$";	// only digit
			// t.requestFocus();
			// //t.on(fgui.TextEvent.Change, this.onInputChange);
		}
		else if( btn.name == "btn_RadioPass1") {
			let t = curPannel.getChild("txt_Password") as fgui.GTextField;
			t.text = "";
			//t.off(fgui.TextEvent.Change, this.onInputChange);
		}
		else if( btn.name == "btn_Password") {
			let c = curPannel.getController("cPassword");
			if( c.selectedIndex == 1 ) this.ShowPasswordPannel();
		}
    }

	private onInputChange(t:fgui.GTextInput):void {
		let s = t.text.slice(-1);
		if( isNaN(parseInt(s)) ) {
			t.text = t.text.slice(0, -1);
		}
		//CGame.DebugLog(t.name, t.text, t.text.length, t.maxLength, s);
	}

	private onClickJoinRoomButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		if ( btn.name == "btn_Cancel") SoundMgr.play("s012");
		else if ( btn.name == "btn_Confirm") SoundMgr.play("s002");
		else SoundMgr.play("s001");
		if ( btn.name == "btn_Confirm") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickJoinRoomButton, false, this);
			curPannel.visible = false;
			let str:string = "";
			for( var i = 0; i < 5; i ++ ) {
				let t = curPannel.getChild("txt_RoomNum"+i) as fgui.GTextField;
				str += t.text;
			}
			CGame.DebugLog("Room Number: ", str);
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_GETINFO);
			this.mGame.m_CPkt.WriteInt(parseInt(str));
			this.mGame.SendData(this.mGame.m_CPkt);
			this.m_curPannel.pop();
		}
		else if ( btn.name == "btn_Cancel") {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickJoinRoomButton, false, this);
			curPannel.visible = false;
			this.m_curPannel.pop();
		}
		else if ( btn.name.slice(0, 7) == "btn_Num") {
			if( btn.name.length >= 9 ) {
				let n = this.m_inIndex - 1;
				if( n >= 0 ) {
					let t = curPannel.getChild("txt_RoomNum"+n) as fgui.GTextField;
					t.text = "";
					this.m_inIndex = n;
				}
			}
			else if( this.m_inIndex < 5 ) {
				let n = parseInt(btn.name.slice(-1));
				CGame.DebugLog(n);
				let t = curPannel.getChild("txt_RoomNum"+this.m_inIndex) as fgui.GTextField;
				t.text = n.toString();
				this.m_inIndex ++;
				//this.m_inText += n.toString();
			}
		}
    }

	private HideCurPannel():void {
		for( let i = 0; i < this.m_curPannel.length; i ++ ) {
			let curPannel = this.m_curPannel.pop();
			curPannel.visible = false;
		}
	}

	public Pause():void {
		super.Pause();
		CGame.DebugLog("Lobby Pause ...");
		this.mainView.visible = false;
		//m_pGame.m_GameStatus = 1;
	}
	
	public Resume():void {
		super.Resume();
		CGame.DebugLog("Lobby Resume ...");
		let avatar = this.mainView.getChild("avatar") as fgui.GLoader;
		avatar.texture = PIXI.Texture.from(this.mGame.m_pUserPlayer.pictureURL);
		this.mGame.m_clTable.Reset();
		this.mainView.visible = true;
		// this.mGame.resetPacket();
		// this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		// this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_ENTER_LOBBY);
		// this.mGame.SendData(this.mGame.m_CPkt);
	}

	private HideWaittingPage():void {
		let curPannel = this.mainView.getChild("com_WaittingPage") as fgui.GComponent;
		if( curPannel ) {
			this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickWaittingPageButton, false, this);
			this.mGame.SetGOCallbackFunc(curPannel, "ldr_Player", 4, this.onClickWaittingPageButton, false, this);
			this.mainView.removeChild(curPannel, true);
		}
		for( var i = 0; i < this.mGame.m_clTable.players; i ++ ) {
			this.mGame.m_clTable.fgAvatar[i] = 0;
		}
		let avatar = this.mainView.getChild("avatar") as fgui.GLoader;
		avatar.texture = null;
		avatar.texture = PIXI.Texture.from(this.mGame.m_pUserPlayer.pictureURL);
		// if( this.m_curPannel.length > 0 ) {
		// 	let curPannel = this.m_curPannel.pop();
		// 	if( curPannel.name == "com_WaittingPage" ) {
		// 		curPannel.visible = false;
		// 		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickWaittingPageButton, false, this);
		// 		this.mGame.SetGOCallbackFunc(curPannel, "ldr_Player", 4, this.onClickWaittingPageButton, false, this);
		// 	}
		// }
	}

	private LeaveWaittingPage():void {
		this.mGame.resetPacket();
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_LEAVE);
		this.mGame.SendData(this.mGame.m_CPkt);
		this.HideWaittingPage();
	}

	private onClickWaittingPageButton(e: PIXI.InteractionEvent): void {
		let btn = fgui.GObject.castFromNativeObject(e.currentTarget);
		CGame.DebugLog(btn.name);
		SoundMgr.play("s002");
		let curPannel = this.m_curPannel[this.m_curPannel.length-1];
		if( btn.name == "btn_Ready" ) {
			this.mGame.resetPacket();
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
			this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_TABLE_READY);
			this.mGame.m_CPkt.WriteShort(this.mGame.m_clTable.index);
			this.mGame.m_CPkt.WriteInt(this.mGame.m_clTable.idxTable);
			this.mGame.SendData(this.mGame.m_CPkt);
			let b = curPannel.getChild("btn_Leave") as fgui.GButton;
			b.enabled = false;
		}
		else if( btn.name == "btn_Leave" ) {
			if( this.mGame.m_clTable.openid[0] == this.mGame.m_pUserPlayer.openid ) {
				var that = this;
				this.mGame.ShowDialog("", "您是否確定要解散房間？", ["確定", "取消"], function (result:boolean) {
					CGame.DebugLog(result);
					if( result ) that.LeaveWaittingPage();
				});
			}
			else {
				this.LeaveWaittingPage();
			}
		}
		else if( btn.name == "btn_Share" ) {
			this.mGame.LINESendMsg(CConfig.gameURL, "好朋友有空嗎？要不要一起來玩無極麻將？房號:"+this.mGame.m_clTable.idxTable);
		}
		else if( btn.name == "btn_Rule" ) {
			this.ShowCreateTablePannel(true, 1);
		}
		else if( btn.name == "btn_Setting" ) {
			this.mGame.ShowSetupDialog();
		}
		else if( btn.name.slice(0, 10) == "ldr_Player" ) {
			let idx = parseInt(btn.name.slice(-1));
			if( this.mGame.m_clTable.openid[idx] ) {
				let x = 107+220 + idx * 155;
				let com = curPannel.getChild("com_Info") as fgui.GComponent;
				if( com.visible && com.x == x ) com.visible = false;
				else {
					let t = com.getChild("txt_Info") as fgui.GTextField;
					t.text = "Name:"+this.mGame.m_clTable.socialName[idx]+"\n"+
							 //"ID:"+this.mGame.m_clTable.openid[idx] + "\n" + 
							 "IP:"+this.mGame.m_clTable.szIP[idx];
					com.x = x;
					com.y = 150;
					com.visible = true;
				}
				CGame.DebugLog(this.mGame.m_clTable.openid[idx], this.mGame.m_clTable.socialName[idx], this.mGame.m_clTable.szIP[idx]);
			}
		}
	}

	private UpdateWaittingPage():void {
		let curPannel = this.getPannelByName("com_WaittingPage") as fgui.GComponent;
		if( curPannel == null ) return;
		let i = 0;
		for( i = 0; i < this.mGame.m_clTable.players; i ++ ) {
			let avatar = curPannel.getChild("ldr_Player"+i) as fgui.GLoader;
			let td = curPannel.getChild("txt_idPlayer"+i) as fgui.GTextField;
			if( td.text != this.mGame.m_clTable.openid[i] ) {
				avatar.texture = null;
				avatar.texture = PIXI.Texture.from(this.mGame.m_clTable.pictureURL[i]);
				td.text = this.mGame.m_clTable.openid[i];
			}
			let mc = curPannel.getChild("mc_Player"+i) as fgui.GMovieClip;
			mc.frame = this.mGame.m_clTable.ready[i];
		}
		for( ; i < CDefine.PLAYER_NUMS; i ++ ) {
			let avatar = curPannel.getChild("ldr_Player"+i) as fgui.GLoader;
			avatar.texture = null;
			let td = curPannel.getChild("txt_idPlayer"+i) as fgui.GTextField;
			td.text = "";
			this.mGame.m_clTable.openid[i] = null;
			let mc = curPannel.getChild("mc_Player"+i) as fgui.GMovieClip;
			mc.frame = 0;
		}
	}

	private ShowWaittingPage():void {
		CGame.DebugLog("ShowWaittingPage");
		let rulePannel = this.mainView.getChild("com_CreateRoom") as fgui.GComponent;
		let curPannel = fgui.UIPackage.createObject("mjLobbyScene", "comWaittingPage") as fgui.GComponent;
		curPannel.name = "com_WaittingPage";
		let idx = this.mainView.getChildIndex(rulePannel);
		this.mainView.addChildAt(curPannel, idx-1);
		//this.mainView.addChild(curPannel);
		//let curPannel = this.mainView.getChild("com_WaittingPage") as fgui.GComponent;
		let t = curPannel.getChild("txt_RoomNumber") as fgui.GTextInput;
		t.text = "房號:" + this.mGame.m_clTable.idxTable;
		let com = curPannel.getChild("com_Info") as fgui.GComponent;
		com.visible = false;
		this.mGame.SetGObjectCallbackFunc(curPannel, this.onClickWaittingPageButton, true, this);
		this.mGame.SetGOCallbackFunc(curPannel, "ldr_Player", 4, this.onClickWaittingPageButton, true, this);
		this.UpdateWaittingPage();
		curPannel.x = 0;
		curPannel.y = -CConfig.gameHT;
		curPannel.visible = true;
		SoundMgr.play("s000");
		createjs.Tween.get(curPannel).to({y:0}, 200, createjs.Ease.quadOut);
		this.m_curPannel.push(curPannel);
		CGame.DebugLog("ShowWaittingPage done.");
	}

	public ProcessMessage(subType:number, p:CByteArray):number {
		var ret:number = 1;
		var i;
		CGame.DebugLog("ProcessLobbyMessage subType:", subType);
		if( subType == CEnumTypes.ID_MSG_ENTER_LOBBY ) {
			let n = p.readInt();
			this.m_BaseList = new Int32Array(n+1);
			this.m_BaseList[0] = n;
			CGame.DebugLog("Base Count:", this.m_BaseList[0]);
			for( i  = 0; i < n; i ++ ) {
				this.m_BaseList[i+1] = p.readInt();
				//CGame.DebugLog(this.m_BaseList[i+1]);
			}

			n = p.readInt();
			this.m_BonusList = new Int32Array(n+1);
			this.m_BonusList[0] = n;
			CGame.DebugLog("Bonus Count:", this.m_BonusList[0]);
			for( i  = 0; i < n; i ++ ) {
				this.m_BonusList[i+1] = p.readInt();
				//CGame.DebugLog(this.m_BonusList[i+1]);
			}
			this.m_multipleBase = p.readInt();
			CGame.DebugLog("m_multipleBase:", this.m_multipleBase);
			n = p.readInt();
			CGame.DebugLog("RoomCards:", n);
			this.mGame.m_pUserPlayer.RoomCards = n;
			n = p.readInt();
			CGame.DebugLog("Gold:", n);
			this.mGame.m_pUserPlayer.Gold = n;
			n = p.readInt();
			CGame.DebugLog("Guild:", n);
			if( this.mGame.m_pUserPlayer.Guild != n ) this.mGame.m_pUserPlayer.Guild = n;
			let t = this.mainView.getChild("txt_RoomCards") as fgui.GTextField;
			t.text = ''+this.mGame.m_pUserPlayer.RoomCards;
		}
		else if( subType == CEnumTypes.ID_MSG_TABLE_CREATE ) {
			let tbl = p.readInt();
			if( tbl > 0 ) {
				this.mGame.m_clTable.idxTable = tbl;
				this.mGame.m_clTable.index = p.readShort();
				this.mGame.m_clTable.Base = p.readInt();
				this.mGame.m_clTable.Bonus = p.readInt();
				this.mGame.m_clTable.Secs = p.readChar();
				this.mGame.m_clTable.fgTinGun = p.readChar();
				this.mGame.m_clTable.fgTingHu = p.readChar();
				this.mGame.m_clTable.Round = p.readChar();
				this.mGame.m_clTable.Cost = p.readChar();
				this.mGame.m_clTable.fgPass = p.readChar();
				this.mGame.m_clTable.commissionZiMo = p.readInt();
				this.mGame.m_clTable.commissionHu = p.readInt();
				this.ShowWaittingPage();
				CGame.DebugLog("Cost:", this.mGame.m_clTable.Cost, this.mGame.m_clTable.commissionZiMo, this.mGame.m_clTable.commissionHu);
			}
			else {
				let errMsg = p.readUTFBytes(CDefine.MAX_ERRMSG_LEN);
				this.mGame.ShowDialog("", errMsg, ["確定"]);
			}
		}
		else if( subType == CEnumTypes.ID_MSG_TABLE_JOIN ) {
			let ret = p.readInt();
			if( ret == 1 ) {
				let curPannel = this.mainView.getChild("com_Guild") as fgui.GComponent;
				if( curPannel.visible ) this.LeaveGuildPannel();
				this.ShowWaittingPage();
			}
			else {
				let errMsg:string = p.readUTFBytes(CDefine.MAX_ERRMSG_LEN);
				this.mGame.ShowDialog("", errMsg, ["確定"]);
			}
		}
		else if( subType == CEnumTypes.ID_MSG_TABLE_STATUS ) {
			this.mGame.m_clTable.players = p.readShort();
			for( i = 0; i < this.mGame.m_clTable.players; i ++ ) {
				this.mGame.m_clTable.ready[i] = p.readByte();
				this.mGame.m_clTable.openid[i] = p.readUTFBytes(CLoginPlayer.OPENID_LEN);
				this.mGame.m_clTable.socialName[i] = p.readUTFBytes(CLoginPlayer.NICKNAME_LEN);
				this.mGame.m_clTable.szIP[i] = p.readUTFBytes(CLoginPlayer.IP_LEN);
				this.mGame.m_clTable.pictureURL[i] = p.readUTFBytes(CLoginPlayer.PICTUREURL_LEN);
				// CGame.DebugLog(this.m_clTable.openid[i], this.m_clTable.socialName[i],
				// 	this.m_clTable.szIP[i], this.m_clTable.pictureURL[i]);
			}
			if( this.mGame.m_clTable.players == 0 ) {
				var that = this;
				this.mGame.ShowDialog("", "房主已解散房間!", ["確定"], function(result:boolean){
					that.mGame.m_clTable.Reset();
					that.HideWaittingPage();
				});
			}
			else {
				this.UpdateWaittingPage();
			}
		}
		else if( subType == CEnumTypes.ID_MSG_TABLE_GETINFO ) {
			CGame.DebugLog("ID_MSG_TABLE_GETINFO:");
			let ret = p.readShort();
			if( ret < 0 ) {
				let errMsg:string = p.readUTFBytes(CDefine.MAX_ERRMSG_LEN);
				CGame.DebugLog(errMsg);
				this.mGame.ShowDialog("", errMsg, ["確定"]);
			}
			else {
				this.mGame.m_clTable.index = ret;
				this.mGame.m_clTable.idxTable = p.readInt();
				this.mGame.m_clTable.Base = p.readInt();
				this.mGame.m_clTable.Bonus = p.readInt();
				this.mGame.m_clTable.Secs = p.readChar();
				this.mGame.m_clTable.fgTinGun = p.readChar();
				this.mGame.m_clTable.fgTingHu = p.readChar();
				this.mGame.m_clTable.Round = p.readChar();
				this.mGame.m_clTable.Cost = p.readChar();
				this.mGame.m_clTable.fgPass = p.readChar();
				// console.log("ID_MSG_TABLE_GETINFO", p.Position, p.size);
				let recon = p.readInt();
				if( recon == 0 ) this.ShowCreateTablePannel(true);
			}
		}
		else if( subType == CEnumTypes.ID_MSG_TABLE_START ) {
			this.mGame.m_clTable.index = p.readShort();
			this.mGame.m_ReLogin = p.readInt();
			this.mGame.m_clTable.password = p.readUTFBytes(10);
			// this.mGame.m_clTable.serverIP = p.readUTFBytes(CLoginPlayer.IP_LEN);
			// this.mGame.m_clTable.serverPort = p.readWord();
			CGame.DebugLog("ID_MSG_TABLE_START:", this.mGame.m_ReLogin, this.mGame.m_clTable.password);
			this.HideCurPannel();
			//this.mGame.PushState(CMJGame.Instance);
			this.mGame.ChangeState(CMJGame.Instance);
		}
		else if( subType == CEnumTypes.ID_MSG_REQUEST_REPLAY ) {
			let ret = p.readInt();
			CGame.DebugLog("ret:"+ret);
			if( ret <= 0 ) {
				p.readInt();
				let errMsg:string = p.readUTFBytes(CDefine.MAX_ERRMSG_LEN);
				CGame.DebugLog(errMsg);
				this.mGame.ShowDialog("", errMsg, ["確定"]);
			}
			else {
				this.mGame.m_clTable.idxTable = p.readInt();
				// this.mGame.ChangeState(CMJReplay.Instance);
				// CMJReplay.Instance.SetData(ret, p);
			}
		}
		else if( subType == CEnumTypes.ID_MSG_GUILD_INFO_UPDATE ) {
			this.UpdateGuidInfo(p);
		}
		else if( subType == CEnumTypes.ID_MSG_GUILD_ENTER ) {
			this.onReceiveGuildEnterData(p);
		}
		else if( subType == CEnumTypes.ID_MSG_GUILD_ROOM_ADD ) {
			this.GuildAddTable(p);
		}
		else if( subType == CEnumTypes.ID_MSG_GUILD_ROOM_REMOVE ) {
			this.GuildRemoveTable(p);
		}
		else if( subType == CEnumTypes.ID_MSG_GUILD_ROOM_UPDATE ) {
			this.GuildUpdateTable(p);
		}
		// else if( subType == CEnumTypes.ID_MSG_IAP_VERIFY_FEEDBACK ) {
		// 	let ret = p.readInt();
		// 	let dbid = p.readInt();
		// 	let rc = p.readInt();
		// 	CGame.DebugLog("ID_MSG_IAP_VERIFY_FEEDBACK:", ret, dbid, rc);
		// 	if( ret == 0 ) {
		// 		let err:string = p.readUTFBytes(1024);
		// 		this.mGame.ShowDialog("內購商品", err, ["確定"]);
		// 		//this.ShowStoreComProcess(false);
		// 	}
		// 	else if( dbid == this.mGame.m_pUserPlayer.DBID ) {
		// 		this.mGame.m_pUserPlayer.RoomCards = rc;
		// 		let t = this.mainView.getChild("txt_RoomCards") as fgui.GTextField;
		// 		t.text = ''+this.mGame.m_pUserPlayer.RoomCards;
		// 		this.mGame.ShowDialog("內購商品", "房卡加值成功！", ["確定"]);
		// 	}
		// 	if( this.getPannelByName("com_StorePage") ) {
		// 		this.LeaveStorePannel();
		// 	}
		// }
		else if( subType == CEnumTypes.ID_MSG_QUIT_GUILD ) {
			let ret = p.readInt();
			let dbid = p.readInt();
			let err:string = p.readUTFBytes(128);
			CGame.DebugLog("ID_MSG_QUIT_GUILD:", ret, dbid);
			if( dbid == this.mGame.m_pUserPlayer.DBID ) {
				if( ret == 1 ) this.mGame.m_pUserPlayer.Guild = 0;
			}
			this.mGame.ShowDialog("", err, ["確定"]);
		}
		return ret;
	}

	public Frame(game: CGameBase): void {
		if( this.mainView == null ) return;

		// if( this.m_WebWnd && this.m_WebWnd.closed ) {
		// 	this.m_WebWnd = null;
		// 	this.mGame.resetPacket();
		// 	this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_LOBBY_SESSION);
		// 	this.mGame.m_CPkt.WriteByte(CEnumTypes.ID_MSG_ENTER_LOBBY);
		// 	this.mGame.SendData(this.mGame.m_CPkt);
		// }

		// if( CGame.Instance.m_tmBlur != 0 && CConfig.gameTarget != "H5" ) {
		// 	let d = new Date();
		// 	let dm = (d.getTime() - CGame.Instance.m_tmBlur) / 1000;
		// 	if( dm >= CGame.secs_RefreshPage ) location.reload();
		// }
	}
}